import { useNavigate, type NavigateFunction } from "react-router-dom";
import { MegaMenu } from "primereact/megamenu";
import { NavbarItems } from "@/data/navbar";
import QubeeLogo from "@/assets/QubeeLogo.png";


function Logo(navigate: NavigateFunction) {
    return (
        <img onClick={() => navigate("/")} className="w-10 h-10 cursor-pointer" src={QubeeLogo} />
    )
}

export function Navbar() {
  const navigate = useNavigate();

  return (
    <div className="w-full fixed p-0 md:p-4 z-50">
        <MegaMenu
          model={NavbarItems(navigate)}
          breakpoint="768px"
          start={Logo(navigate)}
          className="!bg-white/30 !backdrop-blur-md border-none shadow-none"
        />
    </div>
  )
}